import { render, staticRenderFns } from "./CowsPtPurchaseForm.vue?vue&type=template&id=49802fd7&scoped=true&"
import script from "./CowsPtPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./CowsPtPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49802fd7",
  null
  
)

export default component.exports